/** @format */

import { IScoreCardSkuResponse, ProcessedProduct } from '@shared/data-access/interfaces';

import { IScoreCardSkuRequest } from './scorecard-sku-request.interface';
import { Injectable } from '@angular/core';
import { LoyaltyDao } from './loyalty.dao';
import { Observable } from 'rxjs';

import { tap } from 'rxjs/operators';
import { Store } from '../app.store';

@Injectable({
	providedIn: 'root'
})
export class LoyaltyService {
	constructor(
		private loyaltyDao: LoyaltyDao,
		private store: Store
	) {}

	/**
	 * @description
	 * Registers the given email address with Loyalty
	 */
	public registerEmailAddressForLoyalty$(
		emailAddress: string,
		retries?: number
	): Observable<any> {
		return this.loyaltyDao.registerEmailAddressForLoyalty$(emailAddress, retries);
	}

	/**
	 * @description
	 * get eligibility of given list of skus and prices
	 */
	public getScorecardSkuEligibility(product: ProcessedProduct): Observable<any> {
		const Skus: IScoreCardSkuRequest[] = [];
		if (product.skus) {
			for (const sku of product.skus) {
				Skus.push({
					sku: sku.partNumber,
					price: sku.prices.offerPrice.toString()
				});
			}
		}
		return this.loyaltyDao.getScorecardSkuEligibility(Skus).pipe(
			tap((data: IScoreCardSkuResponse[]) => {
				this.store.set('SCORECARD_DATA', data);
			})
		);
	}
}
